export var Name = 'add-to-basket';
export var AddToBasketEvent = Name;
export var Method;

(function (Method) {
  Method["BUY_FOR_MONEY"] = "BUY_FOR_MONEY";
  Method["BUY_FOR_POINTS"] = "BUY_FOR_POINTS";
})(Method || (Method = {}));